import React from 'react';
import { UserRoleEnum } from '../../types';
import { useRolesPermissions } from '../../hooks/useRolesPermission';

type Props = {
  permissions: UserRoleEnum[];
  children: React.ReactNode;
};

function RolePermission({ permissions, children }: Props) {
  const hasPermission = useRolesPermissions(permissions);

  if (!hasPermission) return null;
  return <>{children}</>;
}

export default RolePermission;
